module.exports = __webpack_public_path__ + "img/hero-background-galaxy.ff8b3415.jpeg";